import { render, staticRenderFns } from "./EditWriten.vue?vue&type=template&id=581f98b0&scoped=true&"
import script from "./EditWriten.vue?vue&type=script&lang=ts&"
export * from "./EditWriten.vue?vue&type=script&lang=ts&"
import style0 from "./EditWriten.vue?vue&type=style&index=0&id=581f98b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581f98b0",
  null
  
)

export default component.exports